import React, { useState, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { useHistory } from "react-router";
import firebase from "firebase/app";
import { AuthContext } from "../context/AuthContext";
import getTourById from "../requests/getTourById";
import createGig from "../requests/createGig";
import createProduct from "../requests/createProduct";
import createSalesItemsForTour from "../requests/createSalesItemsForTour";
import getGigsByTour from "../requests/getGigsByTour";
import getProductsByTour from "../requests/getProductsByTour";
import getSalesByTour from "../requests/getSalesByTour";
import getUnitSalesForTour from "../requests/getUnitSalesForTour";
import getRecipientNamesByTour from "../requests/getRecipientNamesByTour";
import TourSummaryProductsTable from "./TourSummaryProductsTable";
import TourSummaryGigsTable from "./TourSummaryGigsTable";
import TourSummaryAddGigForm from "./TourSummaryAddGigForm";
import TourSummaryAddProductForm from "./TourSummaryAddProductForm";

const Tour = () => {

  const { tourId } = useParams();
  const history = useHistory();

  const initialState = {
    gigFields: {
      date: "",
      venue: "",
      venueCut: 0
    },
    productFields: {
      name: "",
      artist: "",
      price: 0,
      recipients: [
        {
          recipientName: "",
          type: "residue",
          split: 100
        }
      ]
    }
  }

  const { user, setUser } = useContext(AuthContext);
  const [ token, setToken ] = useState("");
  const [ gigFields, setGigFields ] = useState(initialState.gigFields);
  const [ productFields, setProductFields ] = useState(initialState.productFields);
  const [ recipientNames, setRecipientNames ] = useState([]);
  const [ gigs, setGigs ] = useState([]);
  const [ products, setProducts ] = useState([]);
  const [ sales, setSales ] = useState([]);
  const [ unitSales, setUnitSales ] = useState([]);
  const [ tour, setTour ] = useState({
    name: "Tour details are loading...",
    gigs: [],
    products: [],
    editors: []
  });

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function(firebaseUser) {
      if (firebaseUser) {
        setUser(firebaseUser);
        firebaseUser.getIdToken().then(token => {
          setToken(token);
          // console.log("JWT:", token);
        })
      } else {
        history.push("/login");
      }
    });
  }, [history, setUser, user])

  useEffect(() => {
    if (token) {
      getTourById(token, tourId).then(response => {
        // console.log(response);
        if (!response.data[0].gigs) {
          response.data[0].gigs = [];
        }
        if (!response.data[0].products) {
          response.data[0].products = [];
        }
        setTour(response.data[0]);
      })
    }
  }, [token, tourId]);

  useEffect(() => {
    if (token) {
      getGigsByTour(token, tourId).then(response => {
        if (response.status === 200) {
          setGigs(response.data);
        } else {
          setGigs([]);
        }
        
      })
      .catch(error => console.log(error));
    }
  }, [token, tourId]);

  useEffect(() => {
    if (token) {
      getProductsByTour(token, tourId).then(response => {
        if (response.status === 200) {
          setProducts(response.data);
        } else {
          setProducts([]);
        }
      })
      .catch(error => console.log(error));
    }
  }, [token, tourId]);

  useEffect(() => {
    if (token) {
      getRecipientNamesByTour(token, tourId).then(response => {
        setRecipientNames(response.data);
      });
    }
  }, [token, tourId]);

  useEffect(() => {
    if (token) {
      getSalesByTour(token, tourId).then(response => {
        if (response.status === 200) {
          setSales(response.data);
        } else {
          setSales([]);
        }
      })
      .catch(error => console.log(error));
    }
  }, [token, tourId, gigs.length]);

  useEffect(() => {
    if (token) {
      getUnitSalesForTour(token, tourId).then(response => {
        if (response.status === 200) {
          setUnitSales(response.data);
        } else {
          setUnitSales([]);
        }
      })
      .catch(error => console.log(error));
    }
  }, [token, tourId]);

  const handleGigFieldChange = (event) => {
    setGigFields((prev) => {
      return {
        ...prev,
        [event.target.name]: event.target.value,
      };
    });
  };

  const handleProductFieldChange = (event, index) => {
    const values = {...productFields};
    if (event.target.name === "name") values.name = event.target.value
    else if (event.target.name === "artist") values.artist = event.target.value
    else if (event.target.name === "price") values.price = event.target.value
    else if (event.target.name === "recipientName") values.recipients[index].recipientName = event.target.value
    else if (event.target.name === "type") values.recipients[index].type = event.target.value
    else if (event.target.name === "split") values.recipients[index].split = event.target.value
    setProductFields(values)
  };

  const handleAddGig = (event) => {
    event.preventDefault();
    if (token) {
      createGig(token, tourId, gigFields)
      .then((response) => {
        const newGig = {...gigFields, _id: response.data.insertedId};
        setGigs((prev) => [
          ...prev, newGig
        ]);
        if (products.length > 0) {
          createSalesItemsForTour(token, tourId).then(response => {
            console.log(response.data);
          });
        }
      });
      setGigFields(initialState.gigFields);
    }
  };

  const handleAddProduct = (event) => {
    event.preventDefault();
    if (token) {
      productFields.price *= 100;
      productFields.recipients.forEach(recipient => {
        if (recipient.type === "prior") recipient.split *= 100;
      });
      createProduct(token, tourId, productFields).then((response) => {
        setProducts((prev) => [
          ...prev, productFields
        ]);
        if (gigs.length > 0) {
          createSalesItemsForTour(token, tourId).then(response => {
            console.log(response);
          });
        }
      });
    }
    setProductFields(initialState.productFields);
  };

  const handleAddProductRecipient = () => {
    const values = {...productFields};
    values.recipients.push({
      recipientName: "",
      type: "residue",
      split: 100
    });
    setProductFields(values);
  }

  if (!user) return (<></>);
  const userIsEditor = tour.editors.includes(user.uid);

  return (
    <div className="container">
      <Link to="/" className="nav-link">All tours</Link>
      <h2 className="heading">{tour.name}</h2>

      <section>
        <h3 className="sub-heading">Gigs on this tour</h3>
        <TourSummaryGigsTable
          token={token}
          tourId={tourId}
          gigs={gigs}
          products={products}
          sales={sales}
          recipientNames={recipientNames}
          userIsEditor={userIsEditor}
        />
      </section>

      {
        userIsEditor &&
        (
          <section id="add-gig">
            <TourSummaryAddGigForm
              handleFieldChange={handleGigFieldChange}
              handleAddGig={handleAddGig}
              gigFields={gigFields}
            />
          </section>
        )
      }

      <section>
        <h3 className="sub-heading">Products for sale on this tour</h3>
        <TourSummaryProductsTable
          token={token}
          tourId={tourId}
          products={products}
          unitSales={unitSales}
          recipientNames={recipientNames}
          userIsEditor={userIsEditor}
        />
      </section>

      {
        userIsEditor &&
        (
          <section>
            <TourSummaryAddProductForm
              handleFieldChange={handleProductFieldChange}
              handleAddProduct={handleAddProduct}
              productFields={productFields}
              handleAddProductRecipient={handleAddProductRecipient}
            />
          </section>
        )
      }
    </div>
  )


};

export default Tour;